import { jsx as _jsx } from "react/jsx-runtime";
import { Logo, LogoWithName } from './svg';
/* istanbul ignore next */ // We don't need to test SVG components
export function SideLogo({ mode = 'light', companyName = false, ...rest }) {
    // TODO: Make these theme colors
    const color = mode === 'light' ? '#FFF' : '#373342';
    const SvgComponent = companyName ? LogoWithName : Logo;
    return _jsx(SvgComponent, { color: color, ...rest });
}
